import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { formReducer, languageReducer } from './../reducers/form';


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const configStore = () => {
  const store = createStore(
      combineReducers({
          form: formReducer,
          language: languageReducer
      }),
    composeEnhancers(applyMiddleware(thunk))
  );
  return store;
};

export default configStore;
